import React from "react";

interface IHelpTextLabelProps {
    title: string;
}

const HelpTextLabel: React.FC<IHelpTextLabelProps> = props => {
    return (
        <div className="info-wrapper">
            <span className="fas fa-info-circle"></span>
            <p>{props.title}</p>
        </div>
    );
};

export default HelpTextLabel;
